import { render, staticRenderFns } from "./AssociateSiteToAssetWidgetComponent.vue?vue&type=template&id=54e1a60e&"
import script from "./AssociateSiteToAssetWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssociateSiteToAssetWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports